import React from 'react';

import { Text } from '@change/ds-core-ui/next';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';

import tileTexture from 'src/assets/legislativeBodies/tiles.jpg';

import { InfoTooltip } from 'src/app/shared/components/tooltips';

import { DecisionMakerCard } from './components/DecisionMakerCard';
import { LegislativeBodyCard } from './components/LegislativeBodyCard';
import { ViewAll } from './components/ViewAll';
import { useDecisionMakers } from './hooks/useDecisionMakers';
import { useTracking } from './hooks/useTracking';
import { MAX_DISPLAYED_DM_CARDS_ON_PETITION } from './shared/types';

export const LegislativeBodiesContainer: React.FC = () => {
	const {
		data: { sortedAllDms, displayViewAllButton },
	} = useDecisionMakers();

	const { trackTooltipClick } = useTracking();
	const { translate } = useI18n();

	return (
		<div className="bg-gradient-background-light-3 md:rounded-large relative mt-20 px-6 py-10">
			<div
				className="md:rounded-large absolute inset-0 bg-repeat opacity-50"
				// eslint-disable-next-line react/forbid-dom-props
				style={{
					backgroundImage: `url(${tileTexture})`,
				}}
			/>
			<div className="z-1 relative flex flex-col gap-6">
				<div className="flex gap-2">
					<Text variant="heading" as="h2" className="text-3xl">
						<Translate value="corgi.petition_gamma.decision_makers_v2.section_title" />
					</Text>
					<InfoTooltip
						aria-label={translate('corgi.petition_gamma.decision_makers_v2.tooltip_label')}
						data-qa="dm-section-tooltip"
						onClick={trackTooltipClick}
						className="my-auto"
					>
						<Translate value="corgi.petition_gamma.decision_makers_v2.tooltip" />
					</InfoTooltip>
				</div>
				{sortedAllDms
					.slice(0, MAX_DISPLAYED_DM_CARDS_ON_PETITION)
					.map((block) =>
						block.component === 'primary' || block.component === 'individual' ? (
							<DecisionMakerCard key={block.componentDm.id} dm={block.componentDm} />
						) : (
							<LegislativeBodyCard
								key={block.componentAttributes.title}
								legislativeBody={{ ...block.componentAttributes, allDMs: block.componentDms }}
							/>
						),
					)}
				{displayViewAllButton && <ViewAll />}
			</div>
		</div>
	);
};
